export default {

	singleVerbs: [
		"Eat",
		"Play",
		"Read",
		"Drive",
		"Walk",
		"Race",
		"Buy",
		"Climb",
		"Call",
		"Skip",
		"Write",
		"Run",
		"Are",
		"Type",
		"Make",
		"Speak",
		"Know",
		"Fly",
		"See",
		"Fold",
		"Give",
		"Take",
		"Offer",
		"Sleep",
		"Dream",
		"Wink",
		"Fear",
		"Have",
		"Talk",
		"Say",
		"Do",
		"Show",
		"Dance"
	],

	pluralVerbs: [
		"Eats",
		"Plays",
		"Reads",
		"Drives",
		"Walks",
		"Races",
		"Buys",
		"Climbs",
		"Calls",
		"Skips",
		"Writes",
		"Runs",
		"Is",
		"Types",
		"Makes",
		"Speaks",
		"Knows",
		"Flies",
		"Sees",
		"Folds",
		"Gives",
		"Takes",
		"Offers",
		"Sleeps",
		"Dreams",
		"Winks",
		"Fears",
		"Has",
		"Talks",
		"Says",
		"Does",
		"Shows",
		"Dances"
	],

	singleNouns: [
		"They",
		"We",
		"You",
		"The children",
		"My daughters",
		"Teachers",
		"Keira and Peyton",
		"The kittens",
		"The boys",
		"My parents",
		"Jake and Shane",
		"The programmers",
		"The artists",
		"Michelle and I",
		"The firefighters",
		"The actors",
		"Laura and Ian",
		"My uncles",
		"The people",
		"Brandon and Grant",
		"The Smiths",
		"You and Emilio",
		"Sofia and Mia",
		"Juan and I",
		"My friends",
		"All of the students",
		"Marco and Stella",
		"She and I",
		"He and Francesco",
		"Rosie and Mia",
		"The firemen",
		"Actors",
		"Myles and I",
		"He and Tony",
		"She and I"
	],

	pluralNouns: [
		"One of the girls",
		"One of the coaches",
		"My daughter",
		"Peyton",
		"The girl",
		"Alan",
		"The doctor",
		"He",
		"Felix",
		"The penguin",
		"Juan",
		"One of them",
		"Andrea",
		"My aunt",
		"Tom",
		"Brandon",
		"Grant",
		"One of the cats",
		"Jake",
		"Rosie",
		"Mia",
		"Giuliana",
		"Riley",
		"Carlos",
		"My friend",
		"One of the students",
		"Seth",
		"David",
		"One of my friends",
		"Francesco",
		"He",
		"She"
	],
}

export const NounVerbsLocalization = {
  "en-US":{
    singleNouns:[
      "Pediatricians",
      "The soccer players",
      "Mrs. Valdez and I",
    ],
    pluralNouns:[
      "Ms. Smith",
      "The soccer team",
      "The group",
		  "The Smith family",
    ]
  },
  "en-GB/AU":{
    singleNouns:[
      "Paediatricians",
      "The football players",
      "Mrs Valdez and I",
    ],
    pluralNouns:[
      "Ms Smith",
    ]
  }
}